import classnames from 'classnames';

import { PasswordStrengthLabel as PasswordStrength } from '../../helpers/passwordStrength';

/**
 * A single "bar" of the password meter.
 *
 * @param {boolean} isActive - Is this bar "active"
 */
const PasswordMeterBar = ({ isActive }: { isActive: boolean; }) => (
  <span className={classnames('fossa-password-meter__bar', {
    'fossa-password-meter__bar--active': isActive,
  })} />
);

/**
 * A generic password strength component.
 * Note that this does not manage making a password strength request, it's just a visual component to display that.
 *
 * @param {PasswordStrength} strength - Current strength (this will be determined in a stateful hook elsewhere).
 */
const PasswordMeter = ({ strength }: { strength: PasswordStrength }) => (
  <div className={classnames('fossa-password-meter', {
    'fossa-password-meter--none': strength === PasswordStrength.None,
    'fossa-password-meter--poor': strength === PasswordStrength.Poor,
    'fossa-password-meter--medium': strength === PasswordStrength.Medium,
    'fossa-password-meter--strong': strength === PasswordStrength.Strong,
    'fossa-password-meter--excellent': strength === PasswordStrength.Excellent,
  })}>
    <PasswordMeterBar isActive={strength > PasswordStrength.None} />
    <PasswordMeterBar isActive={strength > PasswordStrength.Poor} />
    <PasswordMeterBar isActive={strength > PasswordStrength.Medium} />
    <PasswordMeterBar isActive={strength > PasswordStrength.Strong} />
    <span className="fossa-password-meter__label">
      {PasswordStrength[strength]}
    </span>
  </div>
);

export default PasswordMeter;
